export default "__VITE_ASSET__759f48cf__"